
// Not started, Hold, Progress, Delayed, Completed
// export const statusColors = ["#7F7F7F","#FFA726", "#2731C8","#EF5350F2","#00A3A0"] 
export const statusColors = ["#A4ABB6", "#FFB302", "#2DCCFF", "#FF3838", "#56F000"] 